import { AlumniProfileModel } from '@/models/alumni-profile/alumni-profile.model';

export interface AlumniProfileState {
  alumniProfile?: AlumniProfileModel;
  profileToken?: string;
  profiles: { [key: string]: AlumniProfileModel };
}

const state: AlumniProfileState = {
  alumniProfile: undefined,
  profileToken: undefined,
  profiles: {},
};

export default state;
